import React, { useState, useEffect } from "react";
import { FaUsers, FaSignOutAlt, FaList } from "react-icons/fa";
import { IoIosClose } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../components/Image/kiyo_logo.png";
import { MdOutlinePayment } from "react-icons/md";

const ClientSidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeRoute, setActiveRoute] = useState(location.pathname);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setActiveRoute(location.pathname);
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/login");
  };

  const handleNavigate = (route) => {
    if (isMobile) {
      toggleSidebar();
    }
    setActiveRoute(route);
    navigate(route);
  };

  const menuItems = [
    {
      title: "Orders",
      icon: <FaUsers size={16} />,
      route: "/orders",
      stateKey: "orders",
    },
    {
      title: "Payment Details",
      icon: <MdOutlinePayment size={16} />,
      route: "/client/paymentdashboard",
      stateKey: "payment-details",
    },
    {
      title: "Item Master",
      icon: <FaList size={16} />,
      route: "/client/items-master",
      stateKey: "item-master",
    },
    {
      title: "Logout",
      icon: <FaSignOutAlt size={18} />,
      onClick: handleLogout,
      stateKey: "logout",
    },
  ];

  return (
    <aside
      className={`fixed top-0 left-0 z-50 h-full bg-gray-100 shadow-lg transform transition-all duration-300 ease-in-out ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } min-w-52 overflow-y-auto`}
      style={{ scrollbarWidth: "none" }}
    >
      <div className="flex items-center justify-between sm:justify-center px-2 pt-2">
        <img
          src={logo}
          alt="Kiyo International"
          className="h-8 sm:h-16 object-contain"
        />
        <button
          className="text-gray-600 hover:text-red-600 transition-transform duration-300 sm:hidden"
          onClick={toggleSidebar}
          aria-label="Toggle Sidebar"
        >
          <IoIosClose size={24} />
        </button>
      </div>

      <nav className="p-2">
        <ul className="space-y-1">
          {menuItems.map((item) => {
            const isActive = item.route === activeRoute;
            return (
              <li key={item.stateKey}>
                <button
                  onClick={() =>
                    item.onClick ? item.onClick() : handleNavigate(item.route)
                  }
                  className={`w-full grid grid-cols-[min-content_max-content_1fr] cursor-pointer items-center gap-3 p-2 text-sm font-medium transition-all rounded-md duration-200 hover:bg-gray-200 ${
                    isActive
                      ? "bg-gray-200 text-gray-900"
                      : "text-gray-700 hover:text-gray-900"
                  } ${
                    item.title === "Logout"
                      ? "bg-[#d60033] text-white mt-4 hover:bg-red-700"
                      : ""
                  }`}
                  title={item.title}
                >
                  <span
                    className={`text-lg ${
                      item.title === "Logout" ? "text-white" : "text-[#D60033]"
                    } truncate`}
                  >
                    {item.icon}
                  </span>
                  <span className="truncate">{item.title}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};

export default ClientSidebar;
